module.exports = __webpack_public_path__ + "img/v3.b490c319.png";